import { types } from "../types/types"

export const crearErrorAction = (missatgeError) => ({
    type: types.uiCrearError,
    payload: missatgeError
})

export const crearTotOkAction = (missatgeOk) => ({
    type: types.uiCrearOk,
    payload: missatgeOk
})

export const esborrarOkAction = () => ({
    type: types.uiEsborrarOk
})

export const esborrarErrorAction = () => ({
    type: types.uiEsborrarError
})

export const uiIniciarCarregaAction = () => ({
    type: types.uiIniciarCarrega,
    payload: true
})

export const uiFinalitzarCarregaAction = () => ({
    type: types.uiFinalitzarCarrega,
    payload: false
})

export const uiModalUserAction = (valor) => ({
    type: types.uiModalUser,
    payload: valor
})

export const uiIniciarFormularioAction = () => ({
    type: types.uiIniciarFormulario,
    payload: true
})

export const uiFinalitzarFormularioAction = () => ({
    type: types.uiIniciarFormulario,
    payload: false
})

// ─── Acción original: guarda el índice dentro del array contingut ─────────────
// Usada por CercaTable (usuario normal) que sigue cargando todo el historial
export const uiActualizarResultatsAction = (valor) => ({
    type: types.uiActualizarResultats,
    payload: valor
})

// ─── Acción nueva: guarda el objeto completo de evaluación ────────────────────
// Usada por CercaTableADMIN con paginación server-side, donde contingut
// solo contiene la página actual y el índice no es fiable
export const uiActualizarResultatsEvaluacioAction = (evaluacio) => ({
    type: types.uiActualizarResultatsEvaluacio,
    payload: evaluacio
})

export const uiActualizarResultatCatAction = (valor) => ({
    type: types.uiActualizarResultatCat,
    payload: valor
})

export const uiActualizarTextosStateAction = (valor) => ({
    type: types.uiActualizarTextosState,
    payload: valor
})

export const uiActualizarIndicadoresStateAction = (valor) => ({
    type: types.uiActualizarIndicadoresState,
    payload: valor
})